var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStickerScroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#FFBE9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.69 48.718L20.164 35.324l-.002-.617 1.547-1.547.62-.002 8.473 8.39 1.671 1.887-.056-23.381.464-.464 2.094-.005.466.462.056 23.381 1.663-1.895 8.432-8.431.62-.002 1.554 1.54.002.617-13.46 13.46-.62.001z",
    fill: "#DE7C00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "#DE7C00",
    strokeWidth: 3
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjggNjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEuNSIgeT0iMS41IiB3aWR0aD0iNjUiIGhlaWdodD0iNjUiIHJ4PSIzMi41IiBmaWxsPSIjRkZCRTlGIi8+CjxwYXRoIGQ9Ik0zMy42ODkxIDQ4LjcxODRMMjAuMTY0OCAzNS4zMjM5TDIwLjE2MzMgMzQuNzA2NUwyMS43MTA0IDMzLjE1OTVMMjIuMzMwNyAzMy4xNThMMzAuODAyOCA0MS41NDg4TDMyLjQ3NDUgNDMuNDM1NEwzMi40MTgxIDIwLjA1MzdMMzIuODgyMyAxOS41ODk2TDM0Ljk3NTkgMTkuNTg0NkwzNS40NDIyIDIwLjA0NjVMMzUuNDk4NSA0My40MjgxTDM3LjE2MTEgNDEuNTMzNUw0NS41OTI3IDMzLjEwMTlMNDYuMjEzIDMzLjEwMDRMNDcuNzY3NSAzNC42NEw0Ny43NjkgMzUuMjU3NEwzNC4zMDk0IDQ4LjcxN0wzMy42ODkxIDQ4LjcxODRaIiBmaWxsPSIjREU3QzAwIi8+CjxyZWN0IHg9IjEuNSIgeT0iMS41IiB3aWR0aD0iNjUiIGhlaWdodD0iNjUiIHJ4PSIzMi41IiBzdHJva2U9IiNERTdDMDAiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";
export { SvgStickerScroll as ReactComponent };